<div
  class="content-main smooth-animation"
  #lead
  [class.toggled]="isCollapsed"
  [class.sidebar-mobile-open]="isMobileOpen"
>
  <app-header [lead]="lead"></app-header>
  <!-- Mobile Backdrop Overlay -->
  <div
    class="sidebar-backdrop"
    *ngIf="isMobileOpen"
    (click)="closeSidebar()"
    aria-label="Close menu"
  ></div>
  <div class="sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="content-area">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>
</div>